import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import { useTabSelectWithClearSearch } from "../../../util/useTabSelectWithClearSearch";
import ManageShorts from "./ManageShorts";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import ShortComment from "./ShortComment";
import NewShortAdd from "../../dialogue/NewShortAdd";
import { getShortStatsData } from "../../store/shorts/shorts.action";
import StatsCards from "../../extra/StatsCards";
import {
  IconMovie,
  IconLockOpen,
  IconCurrencyDollar,
  IconUserCheck,
  IconUserQuestion,
  IconWorld,
  IconLock,
  IconLinkOff,
  IconBabyCarriage,
  IconMan,
  IconUsersGroup,
  IconMessage,
} from "@tabler/icons-react";

export default function ShortsPage() {
  const dispatch = useDispatch();
  const { multiButtonSelect, setMultiButtonSelect, handleMultiButtonSelect } =
    useTabSelectWithClearSearch("Manage Short");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { dialogueType } = useSelector((state) => state.dialogue);
  const { shortStatsData } = useSelector((state) => state.shorts);

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getShortStatsData(startDateData, endDateData));
  }, [dispatch, startDateData, endDateData]);

  const statsCards = [
    {
      title: "Total Short Videos",
      count: shortStatsData?.totalShortVideos,
      Icon: IconMovie,
    },
    {
      title: "Total Free Short Videos",
      count: shortStatsData?.totalFreeShortVideos,
      Icon: IconLockOpen,
    },
    {
      title: "Total Paid Short Videos",
      count: shortStatsData?.totalPaidShortVideos,
      Icon: IconCurrencyDollar,
    },
    {
      title: "Total Real Short Videos",
      count: shortStatsData?.totalRealShortVideos,
      Icon: IconUserCheck,
    },
    {
      title: "Total Fake Short Videos",
      count: shortStatsData?.totalFakeShortVideos,
      Icon: IconUserQuestion,
    },
    {
      title: "Total Public Short Videos",
      count: shortStatsData?.totalPublicShortVideos,
      Icon: IconWorld,
    },
    {
      title: "Total Private Short Videos",
      count: shortStatsData?.totalPrivateShortVideos,
      Icon: IconLock,
    },
    {
      title: "Total Unlisted Short Videos",
      count: shortStatsData?.totalUnlistedShortVideos,
      Icon: IconLinkOff,
    },
    {
      title: "Total Kids Short Videos",
      count: shortStatsData?.totalKidsShortVideos,
      Icon: IconBabyCarriage,
    },
    {
      title: "Total Adults Short Videos",
      count: shortStatsData?.totalAdultsShortVideos,
      Icon: IconMan,
    },
    {
      title: "Total Both Short Videos",
      count: shortStatsData?.totalBothShortVideos,
      Icon: IconUsersGroup,
    },
    {
      title: "Total Short Comments",
      count: shortStatsData?.totalShortComments,
      Icon: IconMessage,
    },
  ];

  return (
    <div className="userPage videoPage">
      <div
        style={{
          display: `${dialogueType === "editShort" ? "none" : "block"}`,
        }}
      >
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            setMultiButtonSelect={handleMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            labelData={[
              "Manage Short",
              "Manage Short Comment",
              "Import Short",
            ]}
          />
        </div>
        <StatsCards cards={statsCards} />

        {multiButtonSelect == "Manage Short" && (
          <ManageShorts endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Manage Short Comment" && (
          <ShortComment endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Import Short" && (
          <NewShortAdd
            setMultiButtonSelect={setMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
          />
        )}
      </div>
      {dialogueType === "editShort" && <NewShortAdd />}
    </div>
  );
}
